const FilterSummary = ({
  filters,
  updateFilters,
  setPendingDepartments,
  setPendingSkills,
  setPendingJobLocations,
  setPendingExperiences,
  setPendingStatus,
  setPendingCreatedBy,
  setPendingAllowedBranches,  // ⬅️ ADD THIS
  setPendingFromYear,
  setPendingToYear,
  setPendingFromDate,         // ⬅️ ADD THIS
  setPendingToDate,           // ⬅️ ADD THIS
  clearAllFilters
}) => {
  // Updated filter names to match controller
  const hasActiveFilters =
    filters.selectedDepartments?.length > 0 ||
    filters.selectedSkills?.length > 0 ||
    filters.selectedJobLocations?.length > 0 ||
    filters.selectedExperiences?.length > 0 ||
    (filters.selectedStatus !== undefined && filters.selectedStatus !== 'Open') ||
    filters.selectedCreatedBy?.length > 0 ||
    filters.selectedAllowedBranches?.length > 0 ||
    filters.fromDate ||
    filters.toDate;

  if (!hasActiveFilters) return null;

  const handleClearFilter = (filterType, value) => {
    const handlers = {
      selectedDepartments: (updated) => {
        updateFilters({ selectedDepartments: updated });
        setPendingDepartments(updated);
      },
      selectedSkills: (updated) => {
        updateFilters({ selectedSkills: updated });
        setPendingSkills(updated);
      },
      selectedJobLocations: (updated) => {
        updateFilters({ selectedJobLocations: updated });
        setPendingJobLocations(updated);
      },
      selectedExperiences: (updated) => {
        updateFilters({ selectedExperiences: updated });
        setPendingExperiences(updated);
      },
      selectedStatus: () => {
        updateFilters({ selectedStatus: ['Open'] });
        setPendingStatus(['Open']);
      },
      selectedCreatedBy: (updated) => {
        updateFilters({ selectedCreatedBy: updated });
        setPendingCreatedBy(updated);
      },
      selectedAllowedBranches: (updated) => {
        updateFilters({ selectedAllowedBranches: updated });
        setPendingAllowedBranches(updated);
      },
      dateRange: () => {
        updateFilters({ fromDate: '', toDate: '' });
        setPendingFromDate('');
        setPendingToDate('');
      }
    };

    switch (filterType) {
      case 'selectedDepartments':
        const updatedDepts = filters.selectedDepartments.filter(d => d !== value);
        handlers.selectedDepartments(updatedDepts);
        break;
      case 'selectedSkills':
        const updatedSkills = filters.selectedSkills.filter(s => s !== value);
        handlers.selectedSkills(updatedSkills);
        break;
      case 'selectedJobLocations':
        const updatedLocations = filters.selectedJobLocations.filter(l => l !== value);
        handlers.selectedJobLocations(updatedLocations);
        break;
      case 'selectedExperiences':
        const updatedExps = filters.selectedExperiences.filter(e => e !== value);
        handlers.selectedExperiences(updatedExps);
        break;
      case 'selectedStatus':
        handlers.selectedStatus();
        break;
      case 'selectedCreatedBy':
        const updatedCreators = filters.selectedCreatedBy.filter(c => c !== value);
        handlers.selectedCreatedBy(updatedCreators);
        break;
      case 'selectedAllowedBranches':
        const updatedBranches = filters.selectedAllowedBranches.filter(b => b !== value);
        handlers.selectedAllowedBranches(updatedBranches);
        break;
      case 'dateRange':
        const defaultFromDate = (() => {
          const date = new Date();
          date.setMonth(date.getMonth() - 1);
          return date.toISOString().split('T')[0];
        })();
        const defaultToDate = new Date().toISOString().split('T')[0];

        updateFilters({ fromDate: defaultFromDate, toDate: defaultToDate });
        setPendingFromDate(defaultFromDate);
        setPendingToDate(defaultToDate);
        break;
      default:
        break;
    }
  };
  const formatDateDMY = (dateStr) => {
    if (!dateStr) return '...';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };


  return (
    <div className="filter-summary-row">
      <div className="active-filters-summary">
        <span className="filters-label">Active Filters:</span>

        {/* Department Filters */}
        {filters.selectedDepartments?.map((dept, index) => (
          <span key={`department-${index}`} className="filter-badge department">
            Dept: {dept}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedDepartments', dept)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Skills Filters */}
        {filters.selectedSkills?.map((skill, index) => (
          <span key={`skill-${index}`} className="filter-badge skill">
            Skill: {skill}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedSkills', skill)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Job Location Filters */}
        {filters.selectedJobLocations?.map((location, index) => (
          <span key={`location-${index}`} className="filter-badge location">
            Location: {location}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedJobLocations', location)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Experience Filters */}
        {filters.selectedExperiences?.map((exp, index) => (
          <span key={`experience-${index}`} className="filter-badge experience">
            Exp: {exp}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedExperiences', exp)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Status Filter */}
        {Array.isArray(filters.selectedStatus) && filters.selectedStatus.length > 0 && (
          filters.selectedStatus.map((status, index) => (
            <span key={`status-${index}`} className="filter-badge status">
              Status: {status}
              <button
                className="clear-filter-btn"
                onClick={() => {
                  const updated = filters.selectedStatus.filter(s => s !== status);
                  updateFilters({ selectedStatus: updated });
                  setPendingStatus(updated);
                }}
              >
                ×
              </button>
            </span>
          ))
        )}

        {/* Created By Filters */}
        {filters.selectedCreatedBy?.map((creator, index) => (
          <span key={`creator-${index}`} className="filter-badge creator">
            By: {creator}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedCreatedBy', creator)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Allowed Branches Filters */}
        {filters.selectedAllowedBranches?.map((branch, index) => (
          <span key={`branch-${index}`} className="filter-badge branch">
            Branch: {branch}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('selectedAllowedBranches', branch)}
            >
              ×
            </button>
          </span>
        ))}

        {/* Date Range Filter */}
        {(filters.fromDate || filters.toDate) && (
          <span className="filter-badge date-range">
            Date: {formatDateDMY(filters.fromDate)}
            {' to '}
            {formatDateDMY(filters.toDate)}
            <button
              className="clear-filter-btn"
              onClick={() => handleClearFilter('dateRange')}
            >
              ×
            </button>
          </span>
        )}

        <button onClick={clearAllFilters} className="clear-all-btn">
          Clear All
        </button>
      </div>
    </div>
  );
};

export default FilterSummary;